// SAA own-scale display map for the composite grade (acceptance 62-69 / P0-31). The BACKEND grade and
// all client-side logic/comparisons stay on the internal band (AAA…B); this maps to the SAA's own
// scale (SAA-1 strongest, same score breakpoints) ONLY at the point of render, so the notation no
// longer mirrors the S&P/Moody's ladder. Never use for gating/threshold logic.
const GRADE_DISPLAY_MAP: Record<string, string> = {
  WITHHELD: 'NOT ASSIGNED', // SR-276: a withheld composite / grade is not a band
  AAA: 'SAA-1',
  AA: 'SAA-2',
  A: 'SAA-3',
  BBB: 'SAA-4',
  BB: 'SAA-5',
  B: 'SAA-6',
  // SR-252: a binding score whose grade ladder is under revalidation (Market Quality v2) — a state, not a band.
  PENDING_RECALIBRATION: 'GRADE PENDING RECALIBRATION',
  // Coverage interval spans a grade boundary — the letter would depend on unmeasured evidence.
  INDETERMINATE_COVERAGE: 'GRADE INDETERMINATE (COVERAGE)',
};

/** Map an internal grade band to the SAA client scale. Unknown/state values ('WITHHELD','','N/A') pass through. */
export function gradeDisplay(internalGrade?: string | null): string {
  if (internalGrade == null) return '';
  const key = internalGrade.trim().toUpperCase();
  return GRADE_DISPLAY_MAP[key] ?? internalGrade;
}

/** The client-facing grade ladder legend on the SAA scale (single source for "bands" copy). */
export const GRADE_LADDER_TEXT =
  'SAA-1 ≥ 90 · SAA-2 ≥ 85 · SAA-3 ≥ 80 · SAA-4 ≥ 75 · SAA-5 ≥ 70 · SAA-6 < 70'; // SAA-1 strongest
